import React, { useState } from "react";
import { useAppTranslation } from "./TranslationContext";

export const Felina = () => {
  const [showConfetti, setShowConfetti] = useState(false);
    const { t, lang } = useAppTranslation();

  const handleCelebrate = () => {
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 3000);
  };

  return (
    <div className="container">
      <div className="felina">
        <div className="">
        <span>🎉</span>
          <h1>
            {t('congrats')}
          </h1>

          <p className="">
          {t('congratsSub')}
          </p>

          

          {showConfetti && (
            <div className="fixed inset-0 flex items-center justify-center pointer-events-none">
              <div className="text-6xl animate-bounce">🎊🎉✨</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
